import { render, staticRenderFns } from "./noRightPage.vue?vue&type=template&id=71d88416&scoped=true"
import script from "./noRightPage.vue?vue&type=script&lang=js"
export * from "./noRightPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d88416",
  null
  
)

export default component.exports